export default function returnErrorMsg(error) {
  let msg = error?.response?.data?.msg;
  msg = msg ? msg : error.message;

  return { status: 0, msg: msg };
}
